var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#B1BECF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.117 4.835c3.875.053 7.03 3.208 7.082 7.083.056 4.04-3.242 7.337-7.282 7.282-3.874-.054-7.029-3.208-7.082-7.083-.055-4.04 3.243-7.337 7.282-7.282zm-.115 1.105c-3.361.008-6.119 2.82-6.062 6.18.024 1.492.598 2.921 1.612 4.015.027.03.067.046.108.044.041-.002.079-.022.104-.055.308-.404.687-.75 1.117-1.022.879-.564 1.993-.875 3.136-.875 1.144 0 2.258.311 3.137.875.43.272.808.618 1.117 1.022.025.033.062.053.103.055.041.003.081-.014.109-.044 1.037-1.12 1.613-2.59 1.612-4.118 0-3.356-2.73-6.086-6.093-6.077zm.015 2.21c.677 0 1.291.257 1.73.723.445.472.662 1.108.611 1.79-.102 1.354-1.15 2.46-2.34 2.46-1.191 0-2.242-1.106-2.342-2.461-.05-.688.17-1.33.607-1.793.438-.464 1.053-.72 1.734-.72z",
    transform: "translate(-1040 -366) translate(385 177) translate(1 115) translate(647 67) translate(7 7)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUser);
export default __webpack_public_path__ + "static/media/icon-user.b13f1f6b49196b0b73e3e0a48487127b.svg";
export { ForwardRef as ReactComponent };